import { render, staticRenderFns } from "./afterQrcode.vue?vue&type=template&id=6da627d4&scoped=true"
import script from "./afterQrcode.vue?vue&type=script&lang=js"
export * from "./afterQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da627d4",
  null
  
)

export default component.exports